import { getData } from 'api/requests/GET_CONTACT_US';

import { getQueryKey } from 'helpers/getQueryKey';

type Params = { id: string };

export const getContactDataOptions = (params: Params) => {
  return {
    queryKey: getQueryKey('CONTACT_US', params.id),
    queryFn: () => {
      return getData(params.id);
    },
  };
};
